import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import './AnalysisLoading.css';

interface LocationState {
  email: string;
  formData: Record<string, string>;
}

const AnalysisLoading: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  
  const [progress, setProgress] = useState(0);

  const email = state?.email;
  const formData = state?.formData;

  useEffect(() => {
    // Redirect if no email or form data
    if (!email || !formData) {
      navigate('/', { replace: true });
      return;
    }

    // Simulate search progress - faster for better UX
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          // Navigate to results page after loading completes
          setTimeout(() => {
            navigate('/results', { 
              state: { email, formData },
              replace: true 
            });
          }, 300);
          return 100;
        }
        return prev + 3; // Faster progress
      });
    }, 80);

    return () => {
      clearInterval(progressInterval);
    };
  }, [email, formData, navigate]);

  return (
    <div className="analysis-loading">
      <Header />
      <div className="loading-container">
        {/* Circular Progress Spinner - matching screenshot */}
        <div className="circular-progress">
          <svg className="progress-ring" width="120" height="120">
            <circle
              className="progress-ring-background"
              stroke="#f0f0f0"
              strokeWidth="8"
              fill="transparent"
              r="52"
              cx="60"
              cy="60"
            />
            <circle
              className="progress-ring-circle"
              stroke="#ff1744"
              strokeWidth="8"
              fill="transparent"
              r="52"
              cx="60"
              cy="60"
              style={{
                strokeDasharray: `${2 * Math.PI * 52}`,
                strokeDashoffset: `${2 * Math.PI * 52 * (1 - progress / 100)}`,
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%',
                transition: 'stroke-dashoffset 0.1s ease'
              }}
            />
          </svg>
        </div>

        {/* Loading Text - exact text from screenshot */}
        <div className="loading-content">
          <h1 className="loading-title">We are searching for your business</h1>
          <p className="loading-subtitle">Please wait a sec while we search for your website</p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisLoading;
